import { ReactSVG } from "react-svg";
import Icons from "../../assets/icons/index.js";
import { AdminprofileImage, Navbar, Btn, Text } from "../../components/index";
import uploadFunction from "./index.function";
import { fontSizes } from "../../constants/constants.js";
const Uploadfile = () => {
  const {
    navigate,
    handleFormSubmit,
    isDragging,
    handleDrop,
    handleDragOver,
    handleDragLeave,
    fileInputRef,
    handleFileInputChange,
    errorMessage,
    fileName,
    uploadedPDFFileURL,
    fileSize,
    uploadProgress,
    timeLeft,
    formatTimeLeft,
    handleDelete,
    showPopup,
    loadingToapi,
    uploadPDFFileRe,
    TextWeight,
  } = uploadFunction();
  return (
    <div className="flex">
      <Navbar />
      <div className="w-full px-4 lg:px-12 py-10 h-screen overflow-y-scroll hide-scrollbar">
        <AdminprofileImage
          onBack={() => {
            navigate(`/service/category/subcategory`);
          }}
        />
        <Text
          text={"Upload Documents"}
          size={fontSizes.h30}
          weight={TextWeight.Raleway_ExtraBold}
          color="text-black"
          isTruncate={false}
          className={"py-8"}
        />
        <form onSubmit={handleFormSubmit}>
          <div
            className={`py-10 bg-[#E5E5E5] rounded-[35px] flex justify-center flex-col items-center transition-all duration-300 ease-in-out ${
              isDragging
                ? "border-2 border-primary"
                : "border-2 border-transparent"
            }`}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
          >
            <ReactSVG src={Icons.fileIcon} />
            <Text
              text={"drag & drop your files here"}
              size={fontSizes.h18}
              weight={TextWeight.Raleway_ExtraBold}
              color="text-black"
              isTruncate={false}
              className={"pb-3 pt-4 "}
            />
            <input
              id="fileInput"
              type="file"
              className="hidden"
              accept="application/pdf"
              ref={fileInputRef}
              name="pdf"
              onChange={handleFileInputChange}
            />
            <Btn
              onClick={() => document.getElementById("fileInput").click()}
              type={"button"}
              weight={TextWeight.Raleway_SemiBold}
              textSize={fontSizes.h18}
              text={" Choose File"}
              color="text-customBlack"
              bgColor={
                "bg-[#C4C9D0] hover:bg-white border border-[#C4C9D0]  transition duration-300 ease-in-out hover:border-customBlack hover:bg-transparent"
              }
            />
            {errorMessage && (
              <p className="text-red pt-2 text-base lg:text-lg 2xl:text-xl leading-5">
                {errorMessage}
              </p>
            )}
          </div>
          {fileName && (
            <div>
              <Text
                text={"Uploaded File"}
                size={fontSizes.h30}
                weight={TextWeight.Raleway_ExtraBold}
                color="text-black"
                isTruncate={false}
                className={"py-8"}
              />
              <div className="border-2 border-[#B4B0B0] rounded-[35px] px-10 py-10">
                <div className="flex justify-between ">
                  <div className="flex">
                    <ReactSVG src={Icons.fileAttechIcon} className={`w-10`} />
                    <div className="ml-5">
                      <Text
                        text={fileName}
                        size={fontSizes.h18}
                        weight={TextWeight.Raleway_ExtraBold}
                        color="text-black"
                        isTruncate={false}
                      />
                      <Text
                        text={
                          uploadedPDFFileURL
                            ? uploadPDFFileRe
                            : uploadProgress < 100
                            ? `${fileSize} | ${uploadProgress}% - ${
                                timeLeft
                                  ? formatTimeLeft(timeLeft)
                                  : "Uploading..."
                              }`
                            : "Uploading..."
                        }
                        size={fontSizes.h16}
                        weight={TextWeight.Raleway_ExtraBold}
                        color="text-black"
                        isTruncate={false}
                      />
                    </div>
                  </div>
                  <button
                    onClick={handleDelete}
                    type="button"
                    className="border border-transparent hover:border hover:border-current h-full p-1 rounded-lg cursor-pointer"
                  >
                    <ReactSVG className="w-8 h-6" src={Icons.binIcon} />
                  </button>
                </div>
                <div className="relative w-full h-2 bg-[#C4C4C4] overflow-hidden mt-2">
                  <div
                    className={`absolute h-full bg-primary`}
                    style={{ width: `${uploadProgress}%` }}
                  ></div>
                </div>
              </div>
            </div>
          )}
          <Btn
            type={"submit"}
            isDisabled={!uploadedPDFFileURL || loadingToapi}
            loading={loadingToapi}
            isprimary={false}
            weight={TextWeight.Raleway_SemiBold}
            textSize={fontSizes.h18}
            text={"Continue"}
            color="text-white"
            hover={"hover:text-primary hover:bg-white hover:border-primary"}
            bgColor={"bg-primary border-transparent"}
            className={"mx-auto mt-3 sm:mt-5 lg:mt-8"}
          />
        </form>
        {showPopup && (
          <div className="fixed inset-0 backdrop-blur-md px-8 sm:px-24 bg-[#707070] bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-secondary rounded-[35px] text-center">
              <div className="p-10">
                <Text
                  text={
                    "Project Report is being created in background, you may close the window."
                  }
                  size={fontSizes.h18}
                  weight={TextWeight.Raleway_ExtraBold}
                  color="text-black"
                  isTruncate={false}
                  className={"pb-3 pt-4 "}
                />
                <Btn
                  type={"button"}
                  weight={TextWeight.Raleway_SemiBold}
                  textSize={fontSizes.h18}
                  text={"Continue"}
                  onClick={() => navigate("/status")}
                  color="text-white hover:text-primary"
                  bgColor={
                    "bg-primary hover:bg-white hover:border-primary border-transparent"
                  }
                  className={"mx-auto mt-3"}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Uploadfile;
